<div class="downloads-page">
  <h2>Downloaded courses</h2>
  <p class="lp-muted">Everything you've saved for offline reading, by course. Courses you haven't saved anything from yet are still listed, greyed out.</p>

  <div class="downloads-quota" *ngIf="quota">
    <div class="downloads-quota__bar">
      <div class="downloads-quota__fill" [style.width.%]="quota.quota ? (quota.usage / quota.quota) * 100 : 0"></div>
    </div>
    <p class="text-xs">{{ formatBytes(quota.usage) }} used of {{ formatBytes(quota.quota) }} available on this device</p>
  </div>

  <p *ngIf="!loading && courses.length === 0" class="lp-muted">Nothing to show yet.</p>

  <div class="downloads-tree" *ngIf="!loading && courses.length > 0">
    <div class="downloads-course" *ngFor="let course of courses" [class.downloads-course--inert]="!course.expandable">
      <button
        type="button"
        class="downloads-course__header"
        [disabled]="!course.expandable"
        (click)="toggleExpand(course.moduleId)"
      >
        <i class="fa" [ngClass]="course.expandable && isExpanded(course.moduleId) ? 'fa-chevron-down' : 'fa-chevron-right'" aria-hidden="true"></i>
        <span class="downloads-course__title">{{ course.title }}</span>
        <span *ngIf="course.staleVideoCount > 0" class="downloads-course__stale">
          {{ course.staleVideoCount }} video{{ course.staleVideoCount === 1 ? '' : 's' }} updated
        </span>
        <span class="downloads-course__hint" *ngIf="!course.expandable">Nothing saved</span>
      </button>

      <div class="downloads-lessons" *ngIf="course.expandable && isExpanded(course.moduleId)">
        <div class="downloads-lesson" *ngFor="let lesson of course.lessons" [class.downloads-lesson--inert]="!lesson.saved">
          <ng-container *ngIf="lesson.saved; else notSaved">
            <a class="downloads-lesson__title" [routerLink]="['/user/downloadedlesson']" [queryParams]="{ classid: lesson.classId }">{{ lesson.title }}</a>
            <span class="downloads-lesson__size text-xs">{{ formatBytes(lesson.sizeBytes) }}</span>
            <button
              type="button"
              class="btn btn--sm btn--danger m-0"
              [disabled]="removingClassId === lesson.classId"
              (click)="removeLesson(lesson.classId)"
            >
              {{ removingClassId === lesson.classId ? 'Removing...' : 'Remove' }}
            </button>
          </ng-container>
          <ng-template #notSaved>
            <span class="downloads-lesson__title">{{ lesson.title }}</span>
            <span class="downloads-lesson__hint text-xs">Not downloaded</span>
          </ng-template>
        </div>
        <p class="lp-muted text-xs" *ngIf="course.lessons.length === 0">No lessons in this course yet.</p>
      </div>
    </div>
  </div>

  <!-- Offline self-check. Collapsed unless asked for, but the one-line verdict is always
       visible when something is actually wrong, because the failure it describes otherwise
       looks identical to "you have not downloaded anything yet". -->
  <div class="downloads-diagnostics" *ngIf="diagnostics">
    <p class="lp-muted text-xs mb-1">{{ diagnosticsSummary }}</p>
    <button type="button" class="btn btn--sm m-0" (click)="toggleDiagnostics()">
      {{ showDiagnostics ? 'Hide' : 'Show' }} offline self-check
    </button>
    <ng-container *ngIf="showDiagnostics">
      <button type="button" class="btn btn--sm m-0" (click)="copyDiagnostics()">
        {{ diagnosticsCopied ? 'Copied' : 'Copy details' }}
      </button>
      <pre class="downloads-diagnostics__dump text-xs">{{ diagnosticsText }}</pre>
    </ng-container>
  </div>

  <div class="downloads-actions">
    <button type="button" class="btn btn--sm m-0" (click)="requestPersist()">Request persistent storage</button>
    <button type="button" class="btn btn--sm btn--danger m-0" [disabled]="wipingAll || courses.length === 0" (click)="removeAll()">
      {{ wipingAll ? 'Removing...' : 'Remove all downloads' }}
    </button>
  </div>
</div>
